<template>
  <div class="posinegabar-area">
    <div v-for="(item,num) in items" :class="setClassName2(item.num,item.val)" :key="num">
      <div class="itemname" :class="setClassName3(item.img)">{{item.name}}</div>
      <div class="chartsclae">
        <div v-for="n of 10" :class="setClassName(n,item.val)" :key="`sc-${n}`"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pnbardata"],
  data() {
    return {
      items: this.pnbardata,
    };
  },
  computed: {
    setClassName() {
      return function (num, val) {
        // console.log(val);
        let c = num - 6;
        let addC;

        if (c < 0) {
          if (c >= val) {
            addC = " -fillblue";
          } else {
            addC = "";
          }
        } else {
          if (c + 1 <= val) {
            addC = " -fillred";
          } else {
            addC = "";
          }
        }
        return "sc -n" + num + addC;
      };
    },
    setClassName2() {
      return function (num,val) {
        let addC2;
        let color;
        if (num == 0) {
          addC2 = " -large";
        } else {
          addC2 = "";
        }
        color = " -c"+val;
        return "posinega-bar" + color + addC2 ;
      };
    },
    setClassName3() {
      return function (img) {
        let addC3;
        if (img) {
          addC3 = img;
        } else {
          addC3 = "-none";
        }
        return addC3;
      };
    },    
  },
};
</script>


<style lang="scss" scoped>

</style>